import { Link, useLocation } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

type LocationState = { expiredOn?: string | null; email?: string };

export default function SubscriptionExpired() {
  const location = useLocation();
  const state = (location.state || {}) as LocationState;
  const expiredOn = state.expiredOn
    ? new Date(state.expiredOn).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="DataCaffe Logo" className="h-16 w-16 object-contain" />
            <span className="text-2xl font-bold">
              <span style={{ color: '#f97316' }}>ESG</span>
              <span className="text-blue-600 dark:text-blue-400">Caffe</span>
            </span>
          </div>
        </div>

        <Card className="border-0 shadow-xl">
          <CardHeader className="space-y-3 text-center">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/40">
              <AlertTriangle className="h-6 w-6 text-amber-600 dark:text-amber-400" />
            </div>
            <CardTitle className="text-2xl font-bold">Subscription expired</CardTitle>
            <CardDescription>
              {expiredOn
                ? `Your subscription ended on ${expiredOn}.`
                : 'Your subscription has ended.'}{' '}
              To keep using ESGCaffe, please contact your administrator to renew.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <a href="mailto:support@esgcaffe.com" className="block">
              <Button className="w-full">Contact support</Button>
            </a>
            <Link to="/login" className="block">
              <Button variant="outline" className="w-full">
                Back to sign in
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
